import { Skeleton } from "../skeleton";

/**
 * Skeleton for authentication forms (Login, Register, Reset Password)
 * Matches the layout of auth pages with logo, title, and form fields
 */
export function AuthFormSkeleton() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-white to-violet-50 dark:from-gray-950 dark:via-gray-900 dark:to-purple-950/30 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="flex justify-center mb-8">
          <Skeleton className="h-12 w-12 rounded-xl" />
        </div>

        {/* Form Card */}
        <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-xl border border-gray-100 dark:border-gray-800 p-8">
          {/* Title */}
          <div className="text-center mb-6">
            <Skeleton className="h-8 w-48 mx-auto mb-2" />
            <Skeleton className="h-4 w-64 mx-auto" />
          </div>

          {/* Form Fields */}
          <div className="space-y-4">
            {/* Email field */}
            <div>
              <Skeleton className="h-4 w-20 mb-2" />
              <Skeleton className="h-12 w-full rounded-xl" />
            </div>

            {/* Password field */}
            <div>
              <Skeleton className="h-4 w-24 mb-2" />
              <Skeleton className="h-12 w-full rounded-xl" />
            </div>

            {/* Additional field (for register - name, etc.) */}
            <div className="hidden group-[.register]:block">
              <Skeleton className="h-4 w-28 mb-2" />
              <Skeleton className="h-12 w-full rounded-xl" />
            </div>

            {/* Submit button */}
            <Skeleton className="h-12 w-full rounded-xl mt-6" />
          </div>

          {/* Footer links */}
          <div className="mt-6 text-center space-y-2">
            <Skeleton className="h-4 w-56 mx-auto" />
            <Skeleton className="h-4 w-40 mx-auto" />
          </div>
        </div>

        {/* Bottom text */}
        <div className="mt-6 text-center">
          <Skeleton className="h-3 w-64 mx-auto" />
        </div>
      </div>
    </div>
  );
}
